import { BorderStyle } from 'modules/common/components/Border';
import { InteractiveElement } from 'types/interactiveWidget.types';
import { AccessibleElement, Widget } from 'types/widget.types';

export const enum BasicShapeType {
  Rectangle = 'rectangle',
  Ellipse = 'ellipse',
  SemiCircle = 'semi-circle',
  Triangle = 'triangle',
  RightTriangle = 'right-triangle',
  Diamond = 'diamond',
  LeafRight = 'leaf-right',
  LeafLeft = 'leaf-left',
  Pentagon = 'pentagon',
  Hexagon = 'hexagon',
  Octagon = 'octagon',
  QuarterCircle = 'quarter-circle',
  Parallelogram = 'parallelogram',
  Trapezoid = 'trapezoid',
  BlockArrow = 'block-arrow',
  BlockArrowIndent = 'block-arrow-indent',
  Ribbon = 'ribbon',
  DoubleBlockArrow = 'double-block-arrow',
}

interface BasicShapeWidgetData extends Widget, AccessibleElement, InteractiveElement {
  type: BasicShapeType;
  border: {
    color: string;
    width: number;
    style: BorderStyle;
  };
  fillColor: string[];
  fillPercent: number;
  cornerRadius?: number;

  // generic icon data
  mirror: {
    isVertical?: boolean;
    isHorizontal?: boolean;
  };
}

interface BasicShapeLayoutProps {
  // unique id per component instance
  id: string;
  dimension: {
    width: number;
    height: number;
  };
  includeAltTextImg?: boolean;
  offset?: number;
  isReadOnly?: boolean;
}

export type { BasicShapeWidgetData, BasicShapeLayoutProps };
